"use strict";
/**
 * Domain/Business Logic Types
 *
 * Types for frontend components and business logic
 * Optimized for display and user interaction
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./user"), exports);
__exportStar(require("./pattern"), exports);
__exportStar(require("./review"), exports);
__exportStar(require("./notification"), exports);
// The PRODUCT cap on materials per pattern/project. Consumed by BOTH the publish routes and the
// website editor — one definition, because a UI cap that disagrees with the API cap is worse than no
// cap at all (the UI would permit what the API refuses). NOT DynamoDB's transaction-item limit; see
// the header of material-usage-limits.ts for the table separating the two.
__exportStar(require("./material-usage-limits"), exports);
